import React from 'react';
import { useRequestData, useLabels } from 'wsm-common-data';
import propTypes from 'prop-types';

const NationalCharity = ({
	dealerCode,
	charitySubmissionUrl,
	getAttribute,
	charityCodes,
	charitySubmissionSource
}) => {
	const { deviceType } = useRequestData();
	const labels = useLabels();
	const NationalCharityDataMap = [
		// ASPCA
		{
			logoAlt: 'ASPCA Logo',
			logo: getAttribute.path(28),
			bgImageAlt: getAttribute.text(7),
			bgImage: getAttribute.path(7),
			superlative: labels.getHTML(getAttribute.text(82)),
			mission: getAttribute.text(8),
			impact: getAttribute.text(9),
			param: charityCodes[0],
			id: 'aspca'
		},
		// MAW
		{
			logoAlt: 'Make A Wish Logo',
			logo: getAttribute.path(29),
			bgImageAlt: getAttribute.text(11),
			bgImage: getAttribute.path(11),
			superlative: labels.getHTML(getAttribute.text(83)),
			mission: getAttribute.text(12),
			impact: getAttribute.text(13),
			param: charityCodes[1],
			id: 'maw'
		},
		// MOW
		{
			logoAlt: 'Meals on Wheels Logo',
			logo: getAttribute.path(30),
			bgImageAlt: getAttribute.text(15),
			bgImage: getAttribute.path(15),
			superlative: labels.getHTML(getAttribute.text(84)),
			mission: getAttribute.text(16),
			impact: getAttribute.text(17),
			param: charityCodes[2],
			id: 'monw'
		},
		// NPF
		{
			logoAlt: 'National Park Foundation Logo',
			logo: getAttribute.path(31),
			bgImageAlt: getAttribute.text(19),
			bgImage: getAttribute.path(19),
			superlative: labels.getHTML(getAttribute.text(85)),
			mission: getAttribute.text(20),
			impact: getAttribute.text(21),
			param: charityCodes[3],
			id: 'npf'
		}
	];

	const NationalCharityImage = ({ charity }) => {
		return (
			<div className="col-xs-12 col-sm-7 px-0">
				<img
					className="h-100 img-object-fit-cover"
					src={charity.bgImage}
					alt={charity.bgImageAlt}
				/>
			</div>
		);
	};

	NationalCharityImage.propTypes = {
		charity: propTypes.shape({
			bgImageAlt: propTypes.string.isRequired,
			bgImage: propTypes.string.isRequired
		}).isRequired
	};

	const NationalCharityContent = ({ charity, ordinality }) => {
		return (
			<div
				className={`col-xs-12 col-sm-5 p-sm-8 py-8 px-6 ${[
					ordinality
				]}`}
			>
				<img
					className={`${
						deviceType === 'MOBILE' ? 'mt-2' : ''
					} mb-sm-5`}
					src={charity.logo}
					alt={charity.logoAlt}
				/>
				<p className="my-5 text-headline">{charity.impact}</p>
				<p className="mb-6 text-subhead-medium">
					{charity.superlative}
				</p>
				<p className="mb-5">{charity.mission}</p>
				<a
					className={`btn btn-primary btn-sm national-charity-btn mx-sm-none mb-2 rounded ${
						deviceType === 'DESKTOP' ? 'cta-btn-min-width' : 'w-100'
					}`}
					href={`${charitySubmissionUrl}?source=${charitySubmissionSource}&dealerId=${dealerCode}&charity=${charity.param}`}
					target="_blank"
					rel="noopener noreferrer"
				>
					{labels.get('WS_CHOOSE_THIS_CHARITY')}
				</a>
			</div>
		);
	};

	NationalCharityContent.propTypes = {
		charity: propTypes.shape({
			logoAlt: propTypes.string.isRequired,
			logo: propTypes.string.isRequired,
			superlative: propTypes.string.isRequired,
			mission: propTypes.string.isRequired,
			impact: propTypes.string.isRequired,
			param: propTypes.string.isRequired
		}).isRequired,
		ordinality: propTypes.number.isRequired
	};

	return (
		<>
			<h1 className="text-headline text-center bg-white m-0 px-md-15 px-6 pt-8 pb-6">
				{getAttribute.text(26)}
			</h1>
			{NationalCharityDataMap.map((charity, i) => {
				return (
					<div
						id={charity.id}
						className={`d-flex justify-content-center ${
							deviceType === 'MOBILE' ? 'flex-column' : ''
						}`}
						key={charity.id}
					>
						{i % 2 === 1 || deviceType === 'MOBILE' ? (
							<>
								<NationalCharityImage charity={charity} />
								<NationalCharityContent
									charity={charity}
									ordinality={i % 2}
								/>
							</>
						) : (
							<>
								<NationalCharityContent
									charity={charity}
									ordinality={i % 2}
								/>
								<NationalCharityImage charity={charity} />
							</>
						)}
					</div>
				);
			})}
		</>
	);
};

export default NationalCharity;

NationalCharity.propTypes = {
	labels: propTypes.shape({
		get: propTypes.func
	}).isRequired,
	charitySubmissionUrl: propTypes.string.isRequired,
	getAttribute: propTypes.shape({
		text: propTypes.func,
		path: propTypes.func
	}).isRequired,
	dealerCode: propTypes.string.isRequired,
	charityCodes: propTypes.arrayOf,
	charitySubmissionSource: propTypes.string.isRequired,
	charity: propTypes.shape({ id: propTypes.string })
};
